import axiosInstance from '../helpers/axiosInstance'

export const fetchStoreConfig = async (storeId, configKey) => {
  if (!storeId || !configKey) {
    return null
  }

  const data = (async () => {
    try {
      const result = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/stores/${storeId}/configurations?key=${configKey}`)
      return result.data
    } catch (error) {
      return null
    }
  })()

  return data
}

export const fetchStorePackingOptions = async (id, includeGlobalOptions = true) => {
  const response = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/stores/${id}/packing_options`, {
    params: { global_options: includeGlobalOptions },
  })

  return response.data
}

export const fetchStoreBillingConfigurations = async params => {
  const response = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1//store-billing-configurations`, { params: params })
  return response.data
}

export const fetchStores = async (params = {}) => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/stores`, { params })
  return res.data
}

export const fetchStoresWithBillingConfigurations = async (params = {}) => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1//store-billing-configurations/stores`, { params: params })
  return res.data
}

export const createStoreBillingConfiguration = async (storeId, warehouseId, storeBillingConfiguration, storeBillingServices, discardChannelPrices = false) => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-configurations`, {
    ...storeBillingConfiguration,
    store_id: storeId,
    store_billing_services: storeBillingServices,
    warehouse_id: warehouseId,
    ...(discardChannelPrices ? { discard_channel_prices: true } : {}),
  })
  return res.data
}

export const disableBillingAtCutoff = async function (storeId) {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/stores/${storeId}/disable-billing-at-cutoff`)
  return res.data
}

export const fetchStore = async (id, params = {}) => {
  if (id == null) return null
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/stores/${id}`, { params })
  return res.data
}

export const fetchStoreShippingPackages = async (storeId, params) => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/stores/${storeId}/shipping-packages`, { params: params })
  return res.data
}

export const fetchStoreBillingServices = async params => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-services`, { params: params })
  return res.data
}

export const fetchBillingShippingMethods = async params => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-configurations/shipping-methods`, { params: params })
  return res.data
}

export const fetchAvailableChannels = async params => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-services/available-channels`, { params: params })
  return res.data
}

export const createCustomServiceWithUsage = async params => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-services/custom-service-with-usage`, { ...params })
  return res.data
}

export const fetchCustomServicesWithUsages = async params => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-services/current-custom-services-with-usages`, {
    params: params,
  })
  return res.data
}

export const replaceCurrentBillingConfiguration = async (storeId, futureConfigurationId) => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-configurations/replace-current-billing-configuration`, {
    store_id: storeId,
    future_configuration_id: futureConfigurationId,
  })
  return res.data
}

export const getBillingConfigurationReplacementProgress = async jobId => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/user-async-tasks/billing-configuration-replacement/${jobId}`)
  return res.data
}

export const enqueueWarehouseServiceSummaryPreviewExport = async warehouseId => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-statements/export-warehouse-service-summary-preview`, {
    warehouse_id: warehouseId,
  })
  return res.data
}

export const getWarehouseServiceSummaryPreviewExport = async jobId => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/user-async-tasks/billing-service-summary-preview-export/${jobId}`)
  return res.data
}

export const fetchStoreBillingStatements = async params => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store_billing_statements`, { params })
  return res.data
}

export const recalculateStoreBillingStatement = async (statementId, params) => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-statements/${statementId}/recalculate`, params)
  return res.data
}

export const getStatementRecalculationProgress = async jobId => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/user-async-tasks/statement-recalculation/${jobId}`)
  return res.data
}

export const fetchStatementBillingServices = async params => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-services/billing-summary`, { params })
  return res.data
}

export const deleteStoreBillingConfiguration = async configurationId => {
  const res = await axiosInstance.delete(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-configurations/${configurationId}`)
  return res.data
}

export const fetchBillingConfigurationHistory = async params => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/store-billing-configuration-histories`, { params })
  return res.data
}
